export let Dashboard = {};

const formatNumber = (number) => {
  const newNumber = new Intl.NumberFormat('fr-FR', { maximumSignificantDigits: 12 }).format(number);
  return newNumber;
};

document.addEventListener('turbo:load', () => {
  if (document.querySelector('.dashboard-content')) {
    const integrationsNumbers = document.querySelectorAll('.flex-items p');

    integrationsNumbers.forEach((item) => {
      item.textContent = formatNumber(+item.textContent);
      return item.textContent;
    });

    Dashboard.buildingDistributionByIntegrationType.renderChart();
    Dashboard.unitDistributionByIntegrationType.renderChart();
    Dashboard.integrationsByMonth.renderChart();
  }
});
